export default __webpack_public_path__ + "static/media/Dinomascoto.d0a48113.png";